import React from 'react';
import {Box, Typography} from '@mui/material';
import {size} from "@/lib";
import {SubCategory} from "@/types";
import Link from 'next/link'
import ImageFormatter from "@/ui/image-formatter/image-formatter";


interface RelatedBlogsTypes {
    services: SubCategory[];
    title?: string;
    subTitle?: string;
}

const ServicesPanel = ({
                           services,
                           title,
                           subTitle,
                       }: RelatedBlogsTypes) => {

    return (
        <Box sx={(theme) => ({
            maxWidth: size.laptopM,
            borderTop: `1px solid ${theme.palette.primary.dark}`,
            backgroundColor: theme.palette.background.paper,
            py: 4,
            px: 2,
            [theme.breakpoints.down('md')]: {
                textAlign: 'center',
                px: 0,
            },
        })}>
            <Box>
                <Typography variant="h5" component="h4" sx={(theme) => ({
                    fontSize: '24px',
                    m: 0,
                    [theme.breakpoints.down('md')]: {
                        textAlign: 'center',
                    },
                })}>
                    {title}
                </Typography>
                <Typography variant="h6" sx={(theme) => ({
                    fontSize: '14px',
                    color: theme.palette.primary.main,
                })}>
                    {subTitle}
                </Typography>
            </Box>

            <Box
                sx={(theme) => ({
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(176px, 176px))',
                    gap: '3px',
                    justifyItems: 'center',

                    [theme.breakpoints.down('lg')]: {
                        gridTemplateColumns: '1fr',
                    },
                    [theme.breakpoints.down('md')]: {
                        gridTemplateColumns: 'repeat(auto-fit, minmax(176px, 176px))',
                        justifyContent: 'center',
                        px: 0,
                    },
                    [theme.breakpoints.down('sm')]: {
                        gridTemplateColumns: 'repeat(2, 1fr)',
                    },

                })}>
                {services.map((blog: SubCategory) => (
                    <Box
                        key={blog.id}
                        sx={(theme) => ({
                            height: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignContent: 'center',
                            width: '100%',

                            '&:hover': {
                                '& p, h3': {
                                    color: theme.palette.primary.main, // Changes link color on hover
                                },
                            },
                            '& a': {
                                textDecoration: 'none',
                                display: 'block',
                                border: `1px solid #dadde1`,
                                backgroundColor: theme.palette.background.paper,
                                '&:hover': {
                                    // backgroundColor: theme.palette.background.default,
                                    transform: 'background-color 0.3s ease-in-out',
                                    color: theme.palette.primary.dark, // Changes link color on hover
                                    textDecoration: 'underline',
                                },
                            },
                            '& h3,& h4,& h5,& h6,': {
                                margin: 0,
                                fontSize: '14px',
                                p: '5px',
                                alignSelf: 'center',
                                '@media (max-width: 760px)': {
                                    fontSize: '14px', // Adjust font size for 760px viewport
                                }
                            }
                        })}>
                        <Link
                            href={`/${blog.headCategory?.categoryType}/${blog.headCategory?.slug}/${blog.slug}`}
                            title={blog.title}
                            style={{width: '100%'}}
                        >
                            <Typography
                                variant="h4"
                                component="h5"
                                align={'center'}
                            >
                                {blog.title}
                            </Typography>

                            <Box sx={(theme) => ({
                                justifySelf: 'center',
                                width: '100%',
                                [theme.breakpoints.down('lg')]: {
                                    display: 'none',
                                },
                                [theme.breakpoints.down('md')]: {
                                    display: 'block',
                                    width: '100%'
                                },
                            })}>
                                <ImageFormatter isBackground src={blog?.images[0].original}
                                                alt={blog?.images[0].originalAlt} height='99px' width='100%'/>
                            </Box>
                        </Link>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default ServicesPanel;
